<div class="outer-container">
  <div class="inner-container">
    <h1>Sign In</h1>

    <app-sign-in-form
      [buttonText]="'Sign In'"
      (signInRequest)="handleRequest($event)"
    ></app-sign-in-form>

    @if (signInResponse(); as response) {
      @if (!response.success) {
        <span class="error">{{ response.message }}</span>
      }
    }

    <p class="forgot-password">
      <a routerLink="/forgot-password">Forgot Your Password?</a>
    </p>

    @if (spinner()) {
      <mat-spinner></mat-spinner>
    }

    <aside>
      <img
        src="assets/images/icons/referral-program.png"
        alt="Referral program icon"
      />

      <h2>Ready to register for the Online Ordering (Referral) Program?</h2>
      <button
        mat-flat-button
        color="primary"
        routerLink="/become-a-referral-partner"
      >
        Register
      </button>

      <h2>Not familiar with JFW's Online Ordering (Referral) Program?</h2>
      <p>
        No worries!
        <a routerLink="/referral-program-information">Click here</a> to learn
        how you can expand the ways to serve your customers' formalwear needs.
      </p>
    </aside>
  </div>
</div>
